import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authFetch } from '../utils/authFetch';

//const BACKEND_URL = 'http://localhost:3001';
const BACKEND_URL = '/api';

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsError(false);
    setIsSubmitting(true);

    try {
      const res = await authFetch(`${BACKEND_URL}/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => null);
        throw new Error(err?.error || 'Errore nel cambio password');
      }

      setMessage('Password cambiata con successo. Verrai reindirizzato alla dashboard...');
      setIsError(false);

      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);
    } catch (err) {
      setIsError(true);
      setMessage(err.message || 'Errore inatteso durante il cambio password');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormInvalid = !currentPassword || !newPassword;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-4">
      <div className="max-w-md w-full bg-white/95 rounded-2xl shadow-2xl p-8 border border-slate-200">
        <h1 className="text-2xl font-bold text-slate-900 mb-1 text-center">
          Cambia la tua password
        </h1>
        <p className="text-sm text-slate-500 mb-6 text-center">
          Per motivi di sicurezza ti chiediamo di impostare una nuova password personale.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Password attuale
            </label>
            <input
              type="password"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-slate-900"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Inserisci la password temporanea o attuale"
              autoComplete="current-password"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Nuova password
            </label>
            <input
              type="password"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-slate-900"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Scegli una nuova password sicura"
              autoComplete="new-password"
              required
            />
            <p className="mt-1 text-xs text-slate-400">
              Suggerimento: usa almeno 8 caratteri, con lettere maiuscole, minuscole e numeri.
            </p>
          </div>

          {message && (
            <div
              className={`mt-2 text-sm px-3 py-2 rounded-lg ${
                isError
                  ? 'bg-red-50 text-red-700 border border-red-200'
                  : 'bg-emerald-50 text-emerald-700 border border-emerald-200'
              }`}
            >
              {message}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting || isFormInvalid}
            className={`w-full mt-4 py-2.5 rounded-lg font-semibold text-sm tracking-wide
              ${
                isSubmitting || isFormInvalid
                  ? 'bg-slate-300 text-slate-500 cursor-not-allowed'
                  : 'bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg transition'
              }`}
          >
            {isSubmitting ? 'Aggiornamento in corso...' : 'Aggiorna password'}
          </button>
        </form>
      </div>
    </div>
  );
}
